/**
 * UOPX DataLayer event constants.
 * Centralizes event names, locations, text values, and additional data
 * used in trackUOPX calls throughout the application.
 */

// UOPX DataLayer event names
export const UOPX_EVENT = {
  CHAT_WITH_AGENT: "ChatWithAgent",
  CHIP_CLICK: "superPhoebeChipClick",
  SEARCH_TEXT: "superPhoebeSearchText",
  OPTION_SELECTED: "superPhoebeOptionSelected",
  CLOSE: "superPhoebeClose",
  FEEDBACK_SUBMIT: "superPhoebeFeedbackSubmit",
} as const;

// UOPX DataLayer locations
export const UOPX_LOCATION = {
  ICON: "superPhoebeChat : Icon",
  HEADER: "superPhoebeChat : Header",
  POPUP: "superPhoebeChat : Popup",
  FEEDBACK: "superPhoebeChat : Feedback",
  CHIPS: "superPhoebeChat : Chips",
  SEARCH: "superPhoebeChat : Search",
} as const;

// UOPX DataLayer text values
export const UOPX_TEXT = {
  PHOEBE_AI_ASSISTANT: "Phoebe - AI assistant",
  CLOSE: "superPhoebeChat Close",
  START_NEW_CHAT: "Start a new chat",
  GIVE_FEEDBACK: "Give Feedback",
  CANCEL: "Cancel",
} as const;

// UOPX DataLayer additional data
export const UOPX_DATA = {
  CHIP_NAME_HOW_CAN_I_HELP: { name: "How can I help" },
} as const;
